import { render, staticRenderFns } from "./CreateFolderModalContent.vue?vue&type=template&id=1ec76010&"
import script from "./CreateFolderModalContent.vue?vue&type=script&lang=js&"
export * from "./CreateFolderModalContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateFolderModalContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports